(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["erbe-gallery-book"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('erbe-gallery-book')) {
    customElements.define('erbe-gallery-book', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.pages = [...this.querySelectorAll('[data-gallery-page]')];
        this.pageIndex = 0;
        this.select = this.querySelector('[data-page-select]');
        this.select.replaceChildren(...this.pages.map((_, index) => new Option(`Página ${index + 1}`, String(index))));
        this.querySelector('[data-prev]').addEventListener('click', () => this.turn(this.pageIndex - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.turn(this.pageIndex + 1), options);
        this.select.addEventListener('change', () => this.turn(Number(this.select.value)), options);
        this.querySelectorAll('[data-film]').forEach(button => {
          button.addEventListener('click', () => this.playFilm(button), options);
        });
        this.querySelectorAll('[data-sound]').forEach(button => {
          button.addEventListener('click', () => {
            const film = button.closest('.erbe-gallery__film');
            const video = film.querySelector('video');
            if (video) {
              video.muted = !video.muted;
              this.syncSound(video, film);
            }
          }, options);
        });
        this.turn(0);
      }
      turn(index) {
        if (index < 0 || index >= this.pages.length) return;
        this.playAttempt = (this.playAttempt || 0) + 1;
        this.pauseOthers();
        this.activeVideo = null;
        this.pageIndex = index;
        this.pages.forEach((page, i) => { page.hidden = i !== index; });
        this.querySelector('[data-prev]').disabled = index === 0;
        this.querySelector('[data-next]').disabled = index === this.pages.length - 1;
        this.querySelector('[data-page-count]').textContent = `${index + 1} / ${this.pages.length}`;
        this.select.value = String(index);
      }
      pauseOthers(current) {
        this.querySelectorAll('video').forEach(video => {
          if (video === current) return;
          video.pause();
          const film = video.closest('.erbe-gallery__film');
          this.restorePoster(film);
          film.querySelector('[data-sound]').hidden = true;
        });
      }
      playFilm(button) {
        const film = button.closest('.erbe-gallery__film');
        const stage = film.querySelector('[data-stage]');
        let video = stage.querySelector('video');
        if (!video) {
          stage.append(button.querySelector('template').content.cloneNode(true));
          video = stage.querySelector('video');
          video.controls = false;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.disablePictureInPicture = true;
          video.disableRemotePlayback = true;
          video.setAttribute('aria-label', button.closest('figure').querySelector('[data-film-title]').textContent);
          video.addEventListener('contextmenu', event => event.preventDefault(), { signal: this.controller.signal });
          video.addEventListener('play', () => {
            this.pauseOthers(video);
            this.activeVideo = video;
          }, { signal: this.controller.signal });
          video.addEventListener('error', () => {
            if (this.activeVideo === video) this.restorePoster(film);
          }, { signal: this.controller.signal });
        }
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        this.playSound(video, film);
      }
      playSound(video, film) {
        this.pauseOthers(video);
        this.activeVideo = video;
        const sound = film.querySelector('[data-sound]');
        sound.hidden = true;
        const attempt = this.playAttempt = (this.playAttempt || 0) + 1;
        video.muted = false;
        video.volume = 1;
        this.syncSound(video, film);
        const reveal = () => {
          if (!this.isConnected || attempt !== this.playAttempt || video.paused || video.readyState < 2) return;
          const poster = film.querySelector('[data-film]');
          poster.hidden = true;
          poster.disabled = false;
          poster.removeAttribute('aria-busy');
          sound.hidden = false;
          this.syncSound(video, film);
        };
        const revealFrame = () => {
          if (typeof video.requestVideoFrameCallback === 'function') video.requestVideoFrameCallback(reveal);
          else requestAnimationFrame(() => requestAnimationFrame(reveal));
        };
        video.addEventListener('playing', revealFrame, { once: true, signal: this.controller.signal });
        video.play().then(() => {
          if (attempt !== this.playAttempt) video.pause();
          else if (video.readyState >= 2) revealFrame();
        }).catch(() => {
          if (!this.isConnected || attempt !== this.playAttempt) return;
          video.muted = true;
          this.syncSound(video, film);
          video.play().catch(() => {
            if (attempt !== this.playAttempt) return;
            this.restorePoster(film);
          });
        });
      }
      restorePoster(film) {
        const poster = film.querySelector('[data-film]');
        poster.hidden = false;
        poster.disabled = false;
        poster.removeAttribute('aria-busy');
        film.querySelector('[data-sound]').hidden = true;
      }
      syncSound(video, film) {
        const sound = film.querySelector('[data-sound]');
        const label = video.muted ? 'Activar sonido' : 'Silenciar';
        sound.setAttribute('aria-label', label);
        sound.setAttribute('title', label);
        sound.setAttribute('aria-pressed', String(video.muted));
        sound.querySelector('[data-sound-on]').toggleAttribute('hidden', video.muted);
        sound.querySelector('[data-sound-off]').toggleAttribute('hidden', !video.muted);
      }
      disconnectedCallback() {
        this.playAttempt = (this.playAttempt || 0) + 1;
        this.controller?.abort();
        this.pauseOthers();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["erbe-history-book"]) return;
  try {
    
if(!customElements.get('erbe-history-book')){
customElements.define('erbe-history-book',class extends HTMLElement{
connectedCallback(){
this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};
this.pages=[...this.querySelectorAll('[data-page]')];this.index=0;
this.selector=this.querySelector('[data-page-select]');
this.selector.replaceChildren(...this.pages.map((page,index)=>{const option=document.createElement('option');option.value=String(index);const title=page.querySelector('h1,h2,h3')?.textContent.trim()||'Nuestra Historia';option.textContent=(index+1)+' · '+title;return option}));
this.querySelector('[data-jump]').hidden=false;
this.selector.addEventListener('change',()=>this.turn(Number(this.selector.value)-this.index,'fade'),opts);
this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');
this.querySelector('.erbe-book-nav').hidden=false;
this.prev.addEventListener('click',()=>this.turn(-1),opts);this.next.addEventListener('click',()=>this.turn(1),opts);
this.addEventListener('keydown',e=>{if(!e.target.closest('input,textarea,select,[contenteditable]')&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.turn(e.key==='ArrowRight'?1:-1)}},opts);
this.render();
}
disconnectedCallback(){this.abort?.abort();this.animation?.cancel()}
render(){this.pages.forEach((p,i)=>p.hidden=i!==this.index);this.prev.disabled=this.index===0;this.next.disabled=this.index===this.pages.length-1;this.querySelector('[data-count]').textContent=(this.index+1)+' / '+this.pages.length;this.selector.value=String(this.index)}
async turn(delta,mode='slide'){
const next=this.index+delta;if(this.turning||next<0||next>=this.pages.length||next===this.index)return;
this.turning=true;this.selector.disabled=true;
const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
const direction=Math.sign(delta);const outgoing=this.pages[this.index];
try{
if(!reduced){this.animation=outgoing.animate([{opacity:1,transform:'translateX(0)'},{opacity:0,transform:'translateX('+(mode==='slide'?-direction*14:0)+'px)'}],{duration:mode==='slide'?180:130,easing:'ease-in',fill:'forwards'});await this.animation.finished}
if(!this.isConnected)return;
this.index=next;this.render();this.animation?.cancel();
const incoming=this.pages[this.index];incoming.focus({preventScroll:true});incoming.scrollIntoView({block:'start',behavior:'instant'});
if(!reduced){this.animation=incoming.animate([{opacity:0,transform:'translateX('+(mode==='slide'?direction*18:0)+'px)'},{opacity:1,transform:'translateX(0)'}],{duration:mode==='slide'?320:220,easing:'cubic-bezier(.22,.61,.36,1)'});await this.animation.finished}
}catch(error){if(error.name!=='AbortError')throw error}
finally{this.animation?.cancel();this.animation=null;this.turning=false;this.selector.disabled=false}
}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["erbe-mobile-exhibition"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('erbe-work-photos')) {
    customElements.define('erbe-work-photos', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.index = 0;
        this.requestedIndex = 0;
        this.photos = [...this.querySelectorAll('img')];
        this.link = this.closest('a');
        this.link.addEventListener('dragstart', event => event.preventDefault(), options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover) and (pointer: fine)').matches || Number(this.dataset.photoCount) < 2) return;
          this.hydrate();
          this.show(1);
          this.stop();
          if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.timer = setInterval(() => this.show(this.requestedIndex + 1), 1700);
          }
        }, options);
        this.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.stop();
          this.show(0);
        }, options);
        this.link.addEventListener('touchstart', event => {
          this.stop();
          this.suppressUntil = 0;
          const touch = event.touches.length === 1 ? event.touches[0] : null;
          this.touch = touch ? { id: touch.identifier, x: touch.clientX, y: touch.clientY, dx: 0, dy: 0 } : null;
        }, { ...options, passive: true });
        this.link.addEventListener('touchmove', event => {
          if (!this.touch || event.touches.length !== 1) return;
          const touch = [...event.touches].find(point => point.identifier === this.touch.id);
          if (!touch) return;
          this.touch.dx = touch.clientX - this.touch.x;
          this.touch.dy = touch.clientY - this.touch.y;
          if (!this.touch.horizontal && Math.abs(this.touch.dy) > 12 && Math.abs(this.touch.dy) > Math.abs(this.touch.dx) * 1.25) this.touch.vertical = true;
          if (!this.touch.vertical && Math.abs(this.touch.dx) > 12 && Math.abs(this.touch.dx) > Math.abs(this.touch.dy) * 1.25 && Number(this.dataset.photoCount) > 1) {
            this.touch.horizontal = true;
            this.suppressUntil = performance.now() + 1200;
            if (event.cancelable) event.preventDefault();
          }
        }, { ...options, passive: false });
        this.link.addEventListener('touchend', event => {
          const swipe = this.touch;
          this.touch = null;
          if (!swipe?.horizontal) return;
          this.suppressUntil = performance.now() + 1200;
          if (event.cancelable) event.preventDefault();
          if (Math.abs(swipe.dx) < 30) return;
          this.hydrate();
          this.show(this.requestedIndex + (swipe.dx < 0 ? 1 : -1));
        }, { ...options, passive: false });
        this.link.addEventListener('touchcancel', () => { this.touch = null; }, options);
        this.link.addEventListener('click', event => {
          if (performance.now() < (this.suppressUntil || 0)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { ...options, capture: true });
        this.link.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || Number(this.dataset.photoCount) < 2) return;
          event.preventDefault();
          this.hydrate();
          this.show(this.requestedIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
      }
      hydrate() {
        const template = this.querySelector('template');
        if (!template) return;
        this.append(template.content.cloneNode(true));
        template.remove();
        this.photos = [...this.querySelectorAll('img')];
      }
      show(index) {
        index = (index + this.photos.length) % this.photos.length;
        this.requestedIndex = index;
        const photo = this.photos[index];
        photo.loading = 'eager';
        photo.decode().then(() => {
          if (!this.isConnected || this.requestedIndex !== index || !photo.naturalWidth) return;
          this.photos.forEach((image, position) => {
            image.classList.toggle('is-active', position === index);
            image.setAttribute('aria-hidden', String(position !== index));
          });
          this.index = index;
        }).catch(() => {});
      }
      stop() { clearInterval(this.timer); }
      disconnectedCallback() {
        this.stop();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["erbe-video-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('erbe-video-gallery')) {
    customElements.define('erbe-video-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal:this.abort.signal };
        this.cards = [...this.querySelectorAll('[data-film]')];
        this.desktop = matchMedia('(min-width:1100px)');
        this.index = this.desktop.matches ? Math.floor(this.cards.length/2) : 0;
        this.desktop.addEventListener('change',()=>{
          this.start=null;
          if(this.desktop.matches) this.index=Math.floor(this.cards.length/2);
          this.render();
        },options);
        this.visible = false;
        this.stage = this.querySelector('.erbe-films__stage');
        this.querySelector('[data-previous]').addEventListener('click', () => this.move(-1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
        this.stage.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.stage.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.start = {x:event.clientX,y:event.clientY,id:event.pointerId};
          this.stage.setPointerCapture(event.pointerId);
        }, options);
        this.stage.addEventListener('pointerup', event => {
          if (!this.start || event.pointerId !== this.start.id) return;
          const dx = event.clientX-this.start.x;
          const dy = event.clientY-this.start.y;
          this.start = null;
          if (Math.abs(dx)>35 && Math.abs(dx)>Math.abs(dy)) this.move(dx<0 ? 1 : -1);
        }, options);
        this.stage.addEventListener('pointercancel', () => { this.start=null; }, options);
        this.addEventListener('shopify:block:select', event => {
          const index=this.cards.indexOf(event.target.closest('[data-film]'));
          if(index>=0) { this.index=index; this.render(); }
        }, options);
        document.addEventListener('visibilitychange',()=>this.syncVideo(),options);
        this.observer=new IntersectionObserver(entries=>{
          this.visible=entries[0].isIntersecting;
          this.syncVideo();
        },{threshold:.35});
        this.observer.observe(this.stage);
        this.render();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.querySelectorAll('video').forEach(v=>v.pause()); }
      move(step) { this.index=(this.index+step+this.cards.length)%this.cards.length; this.render(); }
      render() {
        const count=this.cards.length;
        this.cards.forEach((card,index)=>{
          const offset=(index-this.index+count)%count;
          const slot=offset>Math.floor(count/2)?offset-count:offset;
          card.style.setProperty('--film-slot',slot);
          card.dataset.position=offset===0?'active':offset===1?'next':offset===count-1?'previous':'hidden';
          card.setAttribute('aria-hidden',String(!this.desktop.matches && offset!==0));
        });
        this.querySelector('[data-status]').textContent=`${this.index+1} / ${count}`;
        this.querySelector('[data-previous]').hidden=count<2;
        this.querySelector('[data-next]').hidden=count<2;
        this.syncVideo();
      }
      syncVideo() {
        this.cards.forEach((card,index)=>{
          const video=card.querySelector('video');
          if(!video) return;
          if(index===this.index && this.visible && !document.hidden && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
            video.muted=true;
            video.play().catch(()=>{});
          } else video.pause();
        });
      }

    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
